import { useState, useEffect } from 'react';
import {
  CONSUMER_CMS_SHOPPING_CART,
  errorMock,
  IGenericErrorCMS,
  useCmsConfig,
  useShoppingCartActivationCostMutation,
} from '@vfit/consumer/data-access';
import { ICommonData, IOptionalText } from '@vfit/shared/models';
import { API, getClickToCallWithKeyOrUrl, trackView } from '@vfit/shared/data-access';
import { CheckboxCards } from '@vfit/consumer/components';
import { useCheckout } from '../../../iBuyFixed.context';
import { ID_FLOWS } from '../../checkout.constants';
import { getCheckoutFWA } from './upfrontSelectionCard.utils';
import TaggingUpfrontSelectionCard from './upfrontSelectionCard.tagging';
import { useQueryClient } from 'react-query';

const UpfrontSelectionCard = ({ handleOnChangeEnableGoNext, handleOnClose }: ICommonData) => {
  const {
    currentStepKey,
    checkoutErrors,
    product,
    upfrontSelection,
    isModalButtonSticky,
    setUpfrontSelection,
    setCurrentStepKey,
  } = useCheckout();
  const queryClient = useQueryClient();
  const [selectedItem, setSelectedItem] = useState<IOptionalText>();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const genericError = useCmsConfig(
    CONSUMER_CMS_SHOPPING_CART,
    API.CMS_GET_GENERIC_ERROR
  ) as IGenericErrorCMS;
  const { checkoutFWA } = getCheckoutFWA(product);
  const updateShoppingCartAtivationCostMutation = useShoppingCartActivationCostMutation();

  const handleSelect = (item: IOptionalText | undefined) => {
    if (item?.value !== undefined && item?.value !== upfrontSelection?.option) {
      setUpfrontSelection({
        option: item.value,
      });
      updateShoppingCartAtivationCostMutation.mutate(item.value === '1');
    }
  };

  useEffect(() => {
    const goNextButton = document.getElementById('sticky-offer-next');
    const trackGoNext = () => {
      const event_label = selectedItem?.value === '1' ? 'one payment' : 'monthly payment';
      trackView({
        event_name: 'ui_interaction',
        event_label_track: event_label,
        event_category: 'users',
        event_action: 'click',
        tracking_type: 'link',
      });
    };
    goNextButton?.addEventListener('click', trackGoNext);
    return () => {
      goNextButton?.removeEventListener('click', trackGoNext);
    };
  }, [selectedItem]);

  useEffect(() => {
    if (updateShoppingCartAtivationCostMutation.isSuccess && handleOnChangeEnableGoNext) {
      handleOnChangeEnableGoNext(true);
      setIsLoading(false);
    }
    if (updateShoppingCartAtivationCostMutation.isLoading && handleOnChangeEnableGoNext) {
      handleOnChangeEnableGoNext(false);
      setIsLoading(true);
    }
    if (updateShoppingCartAtivationCostMutation.isError) {
      checkoutErrors?.showAndTrackError?.(
        genericError,
        handleOnClose,
        {
          ...errorMock('updateShoppingCartPayment', updateShoppingCartAtivationCostMutation?.error),
          isBlocking: true,
        },
        '',
        '',
        handleOnClose,
        genericError?.genericerror?.buttonLabel || '',
        () =>
          getClickToCallWithKeyOrUrl(
            queryClient,
            product?.genericErrorCallMeNow?.url || '',
            product,
            handleOnClose,
            currentStepKey,
            errorMock('updateShoppingCartPayment', updateShoppingCartAtivationCostMutation?.error)
          ),
        product?.genericErrorCallMeNow?.label,
        isModalButtonSticky
      );
    }
  }, [
    updateShoppingCartAtivationCostMutation.isSuccess,
    updateShoppingCartAtivationCostMutation.isLoading,
    updateShoppingCartAtivationCostMutation.isError,
  ]);

  useEffect(() => {
    setSelectedItem(undefined);
    setUpfrontSelection({
      option: '',
    });
    setCurrentStepKey(ID_FLOWS.INVOICE);
    if (handleOnChangeEnableGoNext) {
      handleOnChangeEnableGoNext(false);
    }
  }, []);

  return (
    <div>
      <TaggingUpfrontSelectionCard />
      {checkoutFWA?.items && (
        <CheckboxCards
          items={checkoutFWA?.items}
          title={checkoutFWA?.title}
          description={checkoutFWA?.description}
          setSelectedItem={setSelectedItem}
          selectedItem={selectedItem}
          onSelectItem={handleSelect}
          value={upfrontSelection.option}
          disableItems={isLoading}
        />
      )}
    </div>
  );
};

export default UpfrontSelectionCard;

